<div class="row">
  <div class="col-sm-12 plan-container">
    <div class="brandfont-bold m-t-20 m-b-20">
      <img [src]="contentService.logos[userService.appId][userService.activeTheme].subscriptionBoxAnnual" alt="Fender Studio Pro+" style="max-width: 320px; width: 100%; height: auto" />
      <div class="m-y-20">
        <fui-heading [text]="upsellHeader" [level]="5"></fui-heading>
      </div>

      @if (upsellMessage) {
        <div class="m-b-20 t-16">
          {{ upsellMessage }}
        </div>
      } @else {
        <div class="m-b-20 t-16">{{ "account.plan_fsp_upsell.membership_description" | translate }}</div>
        <ul class="m-b-20" style="padding-left: 20px">
          @for (benefitKey of upsellBenefitKeys; track benefitKey) {
            <li>
              <strong>{{ "account.plan_fsp_upsell.benefits." + benefitKey + ".label" | translate }}</strong>
              - {{ "account.plan_fsp_upsell.benefits." + benefitKey + ".description" | translate }}
            </li>
          }
        </ul>
      }

      <div class="d-flex flex-wrap gap-10">
        <button class="btn btn-primary m-r-10" (click)="upgrade()">{{ "account.plan_fsp_upsell.subscribe_button" | translate }}</button>
        <button class="btn btn-blank" type="button" (click)="learnMoreAboutFspPlus()">{{ "general.learn_more" | translate }}</button>
      </div>
    </div>
  </div>
</div>
